/// <reference path="../../node_modules/@types/jquery/index.d.ts" />


export class IntakeCancelDialog {

    public static Init() {

        $('#noCancelBtn').on('click', function (e) {

            //clear the unobtrusive validation
            $('.field-validation-error').removeClass('field-validation-error').addClass('field-validation-valid').empty();
            $('.input-validation-error').removeClass('input-validation-error').addClass('valid').empty();

            $("#application-form").validate().resetForm();
        });

        $('#okCancelBtn').on('click', (e) => {
            e.preventDefault();
            var cancelUrl: string = $("#confirmCancelUrl").data('request-url');
            window.location.href = cancelUrl;
        });

    }

    ///Used by the SOIT cancel button.
    public static BindConfirmCancelButton() {

        if ($(".confirmCancelButton").length) {
            $(".confirmCancelButton").on("click", (event: JQuery.Event) => {
                if (confirm("Are you sure? Your information will be lost if you cancel")) {
                    return true;
                }
                return false;
            });
        }
    }


}
